import getBookingsSaga from './getBookings';

export const bookingsSagas = [getBookingsSaga];
